export default "__VITE_ASSET__e97817a6__"